const _priceFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  currencySign: "accounting",
  maximumFractionDigits: 0,
});
const _priceFormatter2 = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  currencySign: "accounting",
  maximumFractionDigits: 2,
});

const _priceFormatter_2 = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  currencySign: "accounting",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
const _priceFormatter_4 = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  currencySign: "accounting",
  maximumFractionDigits: 4,
  minimumFractionDigits: 4,
});

export const formatPrice = (value, places) => {
  if (places === 2) {
    //return value?.toFixed(0);
    return _priceFormatter_2.format(value || 0)?.replace("$", "$\u00A0");
  } else if (places === 4) {
    //return value?.toFixed(0);
    return _priceFormatter_4.format(value || 0)?.replace("$", "$\u00A0");
  } else {
    //return value?.toFixed(0);
    return _priceFormatter.format(value || 0)?.replace("$", "$\u00A0");
  }
};

/** Basis: 2 decimals; negative as ($0.99), strictly positive as +$0.99, zero as $0.00 */
export const formatBasis = (value) => {
  if (value === null || value === undefined) return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  const absPart = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(n));
  const money = `$${absPart}`.replace("$", "$\u00A0");
  if (n < 0) return `(${money})`;
  if (n > 0) return `+${money}`;
  return money;
};

export const formatPrice2 = (value) => {
  //return value?.toFixed(0);
  return _priceFormatter2.format(value || 0);
};

export const formatFixed1 = (value) => {
  const places = 1;
  value = (value && Number(value)?.toFixed && Number(value)?.toFixed(places || 0)) || 0;
  return value;
};

export const formatFixed2 = (value) => {
  const places = 2;
  value = (value && Number(value)?.toFixed && Number(value)?.toFixed(places || 0)) || 0;
  return value;
};

export const formatNumber = (value, places) => {
  // return ((value && Number(value)?.toFixed && Number(value)?.toFixed(places || 0)) || 0);

  value = (value && Number(value)?.toFixed && Number(value)?.toFixed(places || 0)) || 0;
  const _numberFormatter = new Intl.NumberFormat("en-US", { minimumFractionDigits: places || 0 });
  return _numberFormatter.format(value);
};

export const formatNumberFinancial = (value, places) => {
  // return ((value && Number(value)?.toFixed && Number(value)?.toFixed(places || 0)) || 0);

  value = (value && Number(value)?.toFixed && Number(value)?.toFixed(places || 0)) || 0;
  const _numberFormatter = new Intl.NumberFormat("en-US", { minimumFractionDigits: places || 0 });
  if (value < 0) {
    return "(" + _numberFormatter.format(value) + ")";
  } else {
    return _numberFormatter.format(value);
  }
};

export const formatBase64Guid = (guid) => {
  // Remove dashes from the GUID
  const cleanGuid = guid.replace(/-/g, "");
  // Convert hex to a byte array
  const byteArray = new Uint8Array(cleanGuid.match(/.{1,2}/g).map((byte) => parseInt(byte, 16)));

  // Convert byte array to Base64
  let base64 = btoa(String.fromCharCode(...byteArray));
  // Modify Base64 to URL-safe and trim the trailing "==" padding
  base64 = base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

  return base64;
};

Math.round_ex = function (number, places) {
  //return +(Math.round(number + "e+" + places) + "e-" + places);
  return Number(number.toFixed(places || 0));
};

export const formatPercentage = (value, places) => {
  return formatNumber((value || 0) * 100, places == null ? 2 : places) + " %";
};

export const formatDate = (date) => {
  // Use toLocaleDateString with options weekday/month/day/year
  // Example: "10/14/2021"
  return new Date(date).toLocaleDateString("en-us", { month: "numeric", day: "numeric", year: "numeric" });
};

export const formatDateWithoutYear = (date) => {
  // Use toLocaleDateString with options weekday/month/day
  // Example: "10/14"
  return new Date(date).toLocaleDateString("en-us", { month: "numeric", day: "numeric" });
};

export const formatDateLong = (date) => {
  // Example: "Tue, Oct 14, 2021"
  return new Date(date).toLocaleDateString("en-us", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const formatDateContext = (date) => {
  if (!date) {
    return null;
  }

  // If it was a few seconds ago, show "Just now"
  // If it was a few minutes ago, show "X minutes ago"
  // If it was today, say "Today"
  // Else, show the date
  const now = new Date();
  const inputDate = new Date(date);
  const diff = now - inputDate;
  const diffMinutes = Math.floor(diff / 60000);
  if (diffMinutes <= 1) {
    return "Just now";
  } else if (diffMinutes < 60) {
    return diffMinutes + " minutes ago";
  } else if (now.toDateString() === inputDate.toDateString()) {
    return "Today";
  } else {
    return inputDate.toLocaleDateString("en-us");
  }
};

export const formatDateTime = (date) => {
  // For today's date, show the time; otherwise, show the date
  const today = new Date();
  const inputDate = new Date(date);
  if (today.toDateString() === inputDate.toDateString()) {
    return inputDate.toLocaleTimeString("en-us");
  } else {
    return inputDate.toLocaleDateString("en-us");
  }
};

// ---

/** First + middle + last; skips empties so missing middle does not leave double spaces. */
export const formatPersonName = (row) => {
  if (!row) return null;
  const name = [
    row.producer_first_name || row.first_name,
    row.producer_middle_name || row.middle_name,
    row.producer_last_name || row.last_name,
  ]
    .map((p) => (p || "").trim())
    .filter(Boolean)
    .join(" ");
  return name || null;
};

export const formatProducerName = (row) => {
  if (!row) return null;

  const personName = formatPersonName(row);
  let nameLabel = row?.producer_business_name || row?.business_name || personName;
  if (row?.account_number) {
    nameLabel += " (" + row.account_number + ")";
  } else if ((row?.producer_business_name || row?.business_name) && personName) {
    nameLabel += " (" + personName + ")";
  }
  return nameLabel;
};

export const formatProducerNameSearchFields = (row) => {
  if (!row) return null;

  let nameLabel = row.producer_business_name || row.business_name || "";
  if (nameLabel?.length > 0) {
    nameLabel += " ";
  }
  nameLabel += formatPersonName(row) || "";
  if (row?.account_number) {
    nameLabel += " (" + row.account_number + ")";
  }
  return nameLabel.trim() || null;
};

// ---

export const PRACTICE_NAME_SHORT_IRRIGATED = "IRR";
export const PRACTICE_NAME_SHORT_NON_IRRIGATED = "NI";
export const PRACTICE_NAME_SHORT_NON_IRRIGATED_SKIP_ROW = "NI/Skip";

export const formatPracticeName = (value) => {
  if (value?.toLowerCase()?.includes("skip row")) {
    return PRACTICE_NAME_SHORT_NON_IRRIGATED_SKIP_ROW;
  } else if (value?.toLowerCase()?.includes("non-irrigated")) {
    return PRACTICE_NAME_SHORT_NON_IRRIGATED;
  } else if (value?.toLowerCase()?.includes("irrigated")) {
    return PRACTICE_NAME_SHORT_IRRIGATED;
  } else {
    return "";
  }
};

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const formatMonthName = (month) => MONTH_NAMES[month - 1] || "";

/**
 * Converts a normalized category name back to human-readable format
 * Handles both snake_case and PascalCase/camelCase formats
 *
 * Examples:
 * - Invoice_Inputs -> Invoice - Inputs
 * - Invoice_Equipment -> Invoice - Equipment
 * - BalanceSheet -> Balance Sheet
 * - FSAForm -> FSA Form
 * - FarmsFSA578Form -> Farms FSA 578 Form
 */
export const formatSnakeCaseToUserFriendly = (snakeCase) => {
  if (!snakeCase) return "";

  let text = snakeCase;

  // Handle suffix replacements first
  if (text.endsWith("_percent") || text.endsWith("_percentage")) {
    text = text.replace(/_percent(age)?$/, "");
    text = text.replace(/_/g, " ");
    text = text.charAt(0).toUpperCase() + text.slice(1);
    return text + " %";
  }

  if (text.endsWith("_name")) {
    text = text.replace(/_name$/, "");
  }

  // Handle underscore format first
  // Invoice_Inputs -> Invoice - Inputs
  // Invoice_Equipment -> Invoice - Equipment
  if (text.includes("_")) {
    text = text.replace(/_/g, " ");
    // Capitalize first letter
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  // Use regex to add spaces intelligently:
  // - Before uppercase letters that follow lowercase letters or digits (BalanceSheet -> Balance Sheet)
  // - Before uppercase letters followed by lowercase, when preceded by uppercase (end of acronym: FSAForm -> FSA Form)
  // This preserves 3+ letter acronyms: FarmsFSA578Form -> Farms FSA 578 Form
  // Pattern explanation:
  //   (?<=[a-z\d]) - positive lookbehind: preceded by lowercase letter or digit
  //   (?=[A-Z])    - positive lookahead: followed by uppercase letter
  //   |            - OR
  //   (?<=[A-Z])   - positive lookbehind: preceded by uppercase letter
  //   (?=[A-Z][a-z]) - positive lookahead: followed by uppercase then lowercase (end of acronym)
  const result = text.replace(/(?<=[a-z\d])(?=[A-Z])|(?<=[A-Z])(?=[A-Z][a-z])/g, " ");

  // Capitalize first letter
  return result.charAt(0).toUpperCase() + result.slice(1);
};

/**
 * Formats a property value for display in document viewers
 * Handles special formatting for numbers, percentages, years, and other types
 *
 * @param {*} value - The value to format
 * @param {string} key - The property key name (used to determine formatting rules)
 * @returns {string} The formatted value
 */
export const formatPropertyPageValue = (value, key = "") => {
  if (value === null || value === undefined) return "";
  if (typeof value === "boolean") return value.toString();

  // Remove trailing _### (e.g., producer_share_percent_1 -> producer_share_percent)
  const keyWithoutNumericSuffix = key.replace(/_\d+$/, "").toLowerCase();

  // Check for special key patterns first (before typeof number check)
  if (keyWithoutNumericSuffix.endsWith("year")) {
    return String(value);
  }

  if (keyWithoutNumericSuffix.endsWith("percent") || keyWithoutNumericSuffix.endsWith("percentage")) {
    if (typeof value === "number") {
      return formatPercentage(value, 2);
    }
    return String(value);
  }

  // Now check for number type
  if (typeof value === "number") {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  }

  if (Array.isArray(value)) return `[${value.length} items]`;
  if (typeof value === "object") return `{${Object.keys(value).length} properties}`;
  return String(value);
};
